import ReactGA from "react-ga4";
import { ENVIRONMENT } from "@/config/config";

const isProduction = () => {
  return ENVIRONMENT === "PROD";
};

export const initTagManager = () => {
  if (!isProduction()) {
    return;
  }
  ReactGA.initialize("G-W0JJV9CYJM");
};

export const trackEvent = (
  category: string,
  action: string,
  label: string,
  parameters?: Record<string, string | number | boolean | undefined>,
) => {
  if (!isProduction()) {
    return;
  }
  ReactGA.event({
    category: category,
    action: action,
    label: label,
    value: 1,
    nonInteraction: true,
    transport: "beacon",
    ...parameters,
  });
};
